import React, { useEffect } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { customStyles, spaceBetween } from '../../../styles';
import { PreviewStackContainer } from './PreviewStackContainer';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { scheduleSlice } from '../../../slices';
import { getSchedulesAction } from '../../../actions';
import { useLocalStorage } from '../../../hooks/useLocalStorage';

export const SetSchedule = () => {
   const style = {
      color: customStyles.colors.main
   }
   const navigate = useNavigate()
   const dispatch = useDispatch()
   const [token] = useLocalStorage('login-token', null)
   const { account, scheduleSelected } = useSelector(state => state.order)
   const { schedules } = useSelector(state => state.schedules)
   const { time, date } = scheduleSelected
   const handleNavigate = () => {
      navigate('/dashboard/date')
   }
   
   // useEffect(() => {
   //    schedules.length === 0 && dispatch(getSchedulesAction(account?.id, token.token))
   // }, [account.id])
  return (
   <PreviewStackContainer text="¿Cuando quieres tu servicio?">
      <Stack width="100%" spacing={2} sx={{
               border: date === null && `1px solid ${customStyles.colors.red}`,
               borderRadius: 1,
               padding: 1
            }}>
         <Box sx={ {...spaceBetween, width:  "100%"} }>
            <Stack direction="row" alignItems="center" spacing={2} >
               <AccessTimeOutlinedIcon sx={style}/>
               {
                  date !== null
                  ?  <Typography component="p" variant="body2">{ date?.day } { date?.date.split('-')[2] } - {time?.start} a {time?.end}</Typography> 
                  :  <Typography component="p" variant="body2">Selecciona un horario de entrega</Typography> 
                  
               }
            </Stack>
            <ModeEditOutlineOutlinedIcon sx={{ color: customStyles.colors.textColor, cursor: 'pointer' }} onClick={handleNavigate}/>
         </Box>
      </Stack>
   </PreviewStackContainer>
  )
}
